"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromRange = fromRange;
exports.toRange = toRange;

var _domSeek = _interopRequireDefault(require("dom-seek"));

var _rangeToString = _interopRequireDefault(require("./range-to-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SHOW_TEXT = 4;

function fromRange(root, range) {
  if (root === undefined) {
    throw new Error('missing required parameter "root"');
  }

  if (range === undefined) {
    throw new Error('missing required parameter "range"');
  }

  var document = root.ownerDocument;
  var prefix = document.createRange();
  var startNode = range.startContainer;
  var startOffset = range.startOffset;
  prefix.setStart(root, 0);
  prefix.setEnd(startNode, startOffset);
  var start = (0, _rangeToString["default"])(prefix).length;
  var end = start + (0, _rangeToString["default"])(range).length;
  return {
    start: start,
    end: end
  };
}

function toRange(root) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (root === undefined) {
    throw new Error('missing required parameter "root"');
  }

  var document = root.ownerDocument;
  var range = document.createRange();
  var iter = document.createNodeIterator(root, SHOW_TEXT);
  var start = selector.start || 0;
  var end = selector.end || start;
  var startOffset = start - (0, _domSeek["default"])(iter, start);
  var startNode = iter.referenceNode;
  var remainder = end - start + startOffset;
  var endOffset = remainder - (0, _domSeek["default"])(iter, remainder);
  var endNode = iter.referenceNode;
  range.setStart(startNode, startOffset);
  range.setEnd(endNode, endOffset);
  return range;
}
//# sourceMappingURL=index.js.map